// Legacy path — the real implementation now lives in the unified
// LoadingSystem. Kept as a shim so existing imports keep working.
export { default } from "../../Components/LoadingSystem/FullPageLoader";
